// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-fd73ba42]{color:#c81919}.method--radio[data-v-fd73ba42]{display:flex;align-items:center}.single--method[data-v-fd73ba42]{display:flex;align-items:center}.single--method img[data-v-fd73ba42]{height:60px;width:90px;object-fit:contain}.single--method .method--name[data-v-fd73ba42]{color:#333;font-size:1.1rem;margin-left:12px}", ""]);
// Exports
module.exports = exports;
